/**
 * TypeScript wrapper around `https://github.com/srfrnk/re-tree`
 *
 * @format
 */
import { RegexLogic } from '@shared/data-access/constants';

export class ReTree {
  public test(string: string, regex: string | RegexLogic | undefined): boolean {
    if (typeof regex === 'string') {
      regex = new RegExp(regex);
    }

    if (regex instanceof RegExp) {
      return regex.test(string);
    } else if (regex && 'and' in regex && Array.isArray(regex.and)) {
      return regex.and.every((item) => this.test(string, item));
    } else if (regex && 'or' in regex && Array.isArray(regex.or)) {
      return regex.or.some((item) => this.test(string, item));
    } else if (regex && 'not' in regex) {
      return !this.test(string, regex.not);
    } else {
      return false;
    }
  }

  public exec(
    string: string,
    regex: string | RegExp | RegExp[] | undefined,
  ): RegExpExecArray | null {
    if (typeof regex === 'string') {
      regex = new RegExp(regex);
    }

    /* istanbul ignore else */
    if (regex instanceof RegExp) {
      return regex.exec(string);
    } else if (regex && Array.isArray(regex)) {
      return regex.reduce(
        (res: RegExpExecArray | null, item) => res ?? this.exec(string, item),
        null,
      );
    } else {
      return null;
    }
  }
}
